module.exports = __webpack_public_path__ + "static/media/spotify.e39d4aac.svg";